import {IconComponent} from '@flixbus/honeycomb-icons-react';
import {getScaledNumber} from '@/Pages/Common/Utils';
import {RegionalCostsDriverCost} from '@/Pages/RegionalCosts/store/types';
import {PartnerCostsDriverCost} from '@/Pages/PartnerCosts/store/types';
import {DriverCostFieldConfig} from './DriverCostsTable.types';

interface DriverCostTableRowConfig {
  title: string;
  icon?: IconComponent;
  originalValue: string | null;
  fallbackValue: string | null;
}

function getRawFallback(
  rowConfig: DriverCostFieldConfig,
  fallbackConfigs: DriverCostFieldConfig[] | undefined,
  fallbackDriverCost: RegionalCostsDriverCost | undefined
): string | null {
  if (!fallbackDriverCost || !fallbackConfigs) return null;

  const originalKey = rowConfig.key;
  const rawFallback = fallbackDriverCost[originalKey];
  return getScaledNumber(String(rawFallback), rowConfig.fractionDigitsCount);
}

export function getDriverCostTableRowConfig(
  rowConfig: DriverCostFieldConfig,
  driverCost: RegionalCostsDriverCost | PartnerCostsDriverCost,
  fallbackConfigs: DriverCostFieldConfig[] | undefined,
  fallbackDriverCost: RegionalCostsDriverCost | undefined
): DriverCostTableRowConfig {
  const title = `${rowConfig.name} (${rowConfig.unit})${
    rowConfig.mandatory ? '*' : ''
  }`;

  const rawOriginal = driverCost[rowConfig.key];
  const originalValue =
    typeof rawOriginal === 'number'
      ? getScaledNumber(String(rawOriginal), rowConfig.fractionDigitsCount)
      : '—';

  const fallbackValue = getRawFallback(
    rowConfig,
    fallbackConfigs,
    fallbackDriverCost
  );

  return {title, icon: rowConfig.icon, originalValue, fallbackValue};
}
